import { arrayUnion, doc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytes, uploadBytesResumable } from 'firebase/storage';
import React, {useState} from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button, Container, Grid, Stack, Typography, styled } from '@mui/material';
import { db } from '../../../firebase';

function UploadImages() {

    const navigate = useNavigate()
    const location = useLocation() 
 
    const docId = location.state
    const [images, setImages] = useState([]);
    const storage = getStorage()
 
      const handleMultipleImageChange = (event) => {
        if (event.target.files && event.target.files.length > 0) { 
          const selectedImages = Array.from(event.target.files);       
          if (selectedImages.length > 10) { 
            const firstTenImages = selectedImages.slice(0, 10);
            uploadImages(firstTenImages) 
          } else {
            uploadImages(selectedImages) 
          }
        }
      };

      const uploadImages = async (images) => {
        const storageRef = ref(storage, `business/`); // Define the storage reference
      
        // eslint-disable-next-line no-async-promise-executor
        const uploadPromises = images.map((image) => new Promise(async (resolve) => {
            const fileRef = ref(storageRef, image.name);
            const uploadTask = uploadBytesResumable(fileRef, image);
      
            // Create a progress bar element for each file
            const progressBar = document.createElement("div");
            progressBar.classList.add("progress-bar");
            progressBar.style.width = "0%"; // Initialize progress to 0%
            progressBar.textContent = "0%";
      
            // Append the progress bar to your UI (e.g., a div with id "progress-bars")
            const progressBarsContainer = document.getElementById("progress-bars");
            progressBarsContainer.appendChild(progressBar);
      
            // Listen to state_changed event to track progress
            uploadTask.on('state_changed',
              (snapshot) => {
                // Calculate progress (percentage uploaded) here for each image
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                progressBar.style.width = `${progress}%`;
                progressBar.textContent = `${Math.round(progress)}%`;
              },
              (error) => {
                console.error(`Error uploading ${image.name}: ${error.message}`);
                resolve(null);
              },
              () => {
                // Upload completed successfully
                getDownloadURL(fileRef).then(async (downloadURL) => {
                  console.log(`File ${image.name} available at ${downloadURL}`);
                  
                  // Update the images array in Firebase for each uploaded image
                  const userDocRef = doc(db, 'business', docId.albumId, "albums", docId.id);
                  await updateDoc(userDocRef, {
                    images: arrayUnion(downloadURL),
                  });
      
                  // Remove the progress bar when the upload is complete
                  progressBarsContainer.removeChild(progressBar);
      
                  resolve(downloadURL);
                });
              }
            );
          }));
      
        try {
          const uploadedImageUrls = await Promise.all(uploadPromises);
          console.log('All images uploaded:', uploadedImageUrls);
          setImages([]); // Clear the uploaded images
           } catch (error) {
          console.error('Error uploading images:', error);
           
        }
      };
      
   
      const StyledProductImg = styled('img')({
       
        width: '100%',
        height: '100%',
        objectFit: 'cover',
  
      });


  return (
    <>
    <Helmet>
      <title> Home</title>
    </Helmet>

    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
         <Typography component={"span"}>Album Name </Typography><br/>
          {docId.name}
        </Typography>  
        <Stack direction={"row"} spacing={3} justifyContent={"center"}>

        {docId.images.length < 10 ? <Typography>Add {10 - docId.images.length} images more <br/>
        <input type="file" onChange={handleMultipleImageChange}  multiple accept="image/*" />
        
        </Typography>
        :
        <Button variant='contained' color='success' onClick={()=>navigate("/dashboard/upgradetopro")}>Upgrade to Pro</Button>}
        </Stack>
 
      </Stack>
        <div id="progress-bars" />
      <Grid container spacing={1}>
        {docId.images.map((h, index)=>(
    <Grid item xs={12} md={3} key={index}>
            <StyledProductImg alt={h} key={index} src={h} />
        </Grid>
        ))}
    </Grid>

    </Container>
  </>
  )
}

export default UploadImages